'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GeckoTableCellsModel = exports.GeckoTableCellModel = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeckoTableCellModel = exports.GeckoTableCellModel = {
	key: _propTypes2.default.string,
	type: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_CURRENCY, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_DATE, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_NAME, _constants.GECKO_CONSTS.TABLE_CELL_TYPE_STATUS]),
	name: _propTypes2.default.string,
	class: _propTypes2.default.string,
	align: _propTypes2.default.oneOf(['left', 'center', 'right']),
	render: _propTypes2.default.func,
	renderComponent: _propTypes2.default.func,
	handler: _propTypes2.default.func,
	width: _propTypes2.default.string,
	sortable: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};

var GeckoTableCellsModel = exports.GeckoTableCellsModel = _propTypes2.default.arrayOf(_propTypes2.default.shape(GeckoTableCellModel));